export default __webpack_public_path__ + "static/media/f_md-4.7d063a3c.svg";